import { formatPhoneNumber } from "../../../Common/utils/universalFuntions";

const buildDynamicBlocksForReferalForm = ({ clientsArray = [], type, labelType, RTDInitiator }) => {
  try {
    let html = "";
    const editIconDataAttr = "data-buyer-details-edit-icon";
    const editModalTitle = type === "CLIENT" ? "Client" : labelType === "REFERRING_AGENT" ? "Referring Agent" : "Receiving Agent";
    const clientAttribute = RTDInitiator === "BUYER" ? "data-buyer-edit-icon" : "data-seller-edit-icon";
    // console.log({ clientsArray, type, labelType, });
    const corpClients = clientsArray.filter((el) => el.isCorp);
    if (!clientsArray?.length || (corpClients?.length && !corpClients[0]?.signers?.length)) {
      if (type === "CLIENT") {
        return `
            <div  style="border: 1px solid #000; padding: 10px; margin-bottom: 10px;">
              <table class="tableWidth" style="border: 0; width: 100%;">
                <tr>
                  <td>
                    <div class="no-block" style="display: flex; align-items: center;">
                      Client's Name: <span class="ua" style="margin-left: 8px;"></span>
                        <i class="bi bi-plus  no-print clickable"   ${clientAttribute}  data-edit-modal-title="${editModalTitle}" data-labelType="${labelType}"
                          style="
                            background-color: #085191;  
                            color: white;
                            margin-left: 30px;
                            border-radius: 50%;
                            padding: 8px;
                            font-size: 25px;
                            display: inline-flex;
                            align-items: center;
                            justify-content: center;
                            width: 30px;
                            height: 30px;
                            cursor: pointer;
                          "
                        ></i>
                      </div>
                  </td>
                </tr>
                <tr><td style="padding-left: 20px;">Address: <span class="ua"></span></td></tr>
                <tr><td style="padding-left: 20px;">Phone: <span class="ua"></span></td></tr>
                <tr><td style="padding-left: 20px;">Email: <span class="ua"></span></td></tr>
                <tr><td style="padding-left: 20px;">
                  Client is
                  <input class="clickable noAutoSave"  type="checkbox"  data-referal-form-client-checkbox data-cb-group="ClientType"  name="ClientType" value="Selling" data-checkbox-list="">&nbsp;<span class="tb">Buying</span>   <input class="clickable noAutoSave" type="checkbox" data-referal-form-client-checkbox  data-cb-group="ClientType" name="ClientType" value="Buying" data-checkbox-list="">&nbsp;<span class="tb">Selling</span>
                </td></tr>
              </table>
            </div>`;
      } else if (type === "AGENT") {
        return `
            <div style="border: 1px solid #000; padding: 10px; margin-bottom: 10px;">
              <div class="no-block" style="display: flex;  align-items: center;  margin-bottom: 10px;">
                 ${labelType === "REFERRING_AGENT" ? "Referred From:" : "Referred To:"}
               <i class="bi bi-plus  no-print clickable"  ${clientAttribute}  data-edit-modal-title="${editModalTitle}" data-labelType="${labelType}" data-add-as-self
                style="
                  background-color: #085191;  
                  color: white;
                  margin-left: 30px;
                  border-radius: 50%;
                  padding: 8px;
                  font-size: 25px;
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  width: 30px;
                  height: 30px;
                  cursor: pointer;
                "
              ></i>
              </div>
              <table class="tableWidth" style="border: 0; width: 100%;">
                <tr><td style="padding-left: 20px;">Company Name: <span class="ua"></span></td></tr>
                <tr><td style="padding-left: 20px;">Company Address: <span class="ua"></span></td></tr>
                <tr><td style="padding-left: 20px;">Company Phone: <span class="ua"></span></td></tr>
                <tr><td style="padding-left: 20px;">Fax #: <span class="ua"></span> </td></tr>
                <tr><td style="padding-left: 20px;">Agent Name: <span class="ua"></span></td></tr>
                <tr><td style="padding-left: 20px;">Agent Phone: <span class="ua"></span></td></tr>
                <tr><td style="padding-left: 20px;">Agent Email: <span class="ua"></span></td></tr>
              </table>
            </div>`;
      }
    }
    if (type === "CLIENT") {
      clientsArray.forEach((element) => {
        if (element.isCorp) {
          element.signers.forEach((signer) => {
            html += `
                <div  style="border: 1px solid #000; padding: 10px; margin-bottom: 10px;">
                  <table class="tableWidth" style="border: 0; width: 100%;">
                    <tr><td > <div class="no-block" style="display: flex; align-items: center;"> Client's Name: <span class="ua" style="margin-left: 4px;">${signer.fullName || ""}</span> 
                    
                    <i class="bi bi-pencil-square no-print clickable"
                    ${editIconDataAttr}
                      data-corp-signer 
                      data-edit-modal-title="${editModalTitle}"
                    data-signer-personId="${signer.personId}"
                    data-signer-uuid-key="${element.key}"
                    style="color: blue; margin-left: 10px;"></i>  <i class="bi bi-plus  no-print clickable"  ${clientAttribute}  data-edit-modal-title="${editModalTitle}" data-labelType="${labelType}"
                      style="
                        background-color: #085191;  
                        color: white;
                        margin-left: 30px;
                        border-radius: 50%;
                        padding: 8px;
                        font-size: 25px;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        width: 30px;
                        height: 30px;
                        cursor: pointer;
                      "
                    ></i></div> </td>   
                    </tr>
                    <tr><td style="padding-left: 20px;">Address: <span class="ua">${signer.address || ""}</span></td></tr>
                    <tr><td style="padding-left: 20px;">Phone: <span class="ua">${formatPhoneNumber(signer.phoneNumber)}</span></td></tr>
                    <tr><td style="padding-left: 20px;">Email: <span class="ua">${signer.email || ""}</span></td></tr>
                      <tr><td style="padding-left: 20px;">  Client is  <input type="checkbox" data-cb-group="ClientType"  name="${signer.personId}_ClientType" value="Selling" data-checkbox-list="">&nbsp;<span class="tb">Buying</span>   <input type="checkbox" data-cb-group="ClientType" name="${signer.personId}_ClientType" value="Buying" data-checkbox-list="">&nbsp;<span class="tb">Selling</span>  </td></tr>
                  </table>
                </div>`;
          });
        } else {
          const uuidKey = element.key || element.personId;
          const personId = element.personId || element._id;
          html += `
            <div  style="border: 1px solid #000; padding: 10px; margin-bottom: 10px;">
                  <table class="tableWidth" style="border: 0; width: 100%;">
                    <tr><td >    <div class="no-block" style="display: flex; align-items: center; ">Client's Name: <span class="ua" style="margin-left: 4px;">${element.fullName || ""}</span> <i class="bi bi-pencil-square no-print clickable"
                    ${editIconDataAttr}
                      data-edit-modal-title="${editModalTitle}"
                data-signer-personId="${personId}"
                data-signer-uuid-key="${uuidKey}"
                style="color: blue; margin-left: 10px;"></i>    <i class="bi bi-plus  no-print clickable"  ${clientAttribute}  data-edit-modal-title="${editModalTitle}" data-labelType="${labelType}"
               style="
                background-color: #085191;  
                color: white;
                margin-left: 30px;
                border-radius: 50%;
                padding: 8px;
                font-size: 25px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 30px;
                height: 30px;
                cursor: pointer;
              "
            ></i> </div></td> </tr>
                    <tr><td style="padding-left: 20px;">Address: <span class="ua">${element.address || ""}</span></td></tr>
                    <tr><td style="padding-left: 20px;">Phone: <span class="ua">${formatPhoneNumber(element.phoneNumber)}</span></td></tr>
                    <tr><td style="padding-left: 20px;">Email: <span class="ua">${element.email || ""}</span></td></tr>
                        <tr><td style="padding-left: 20px;">  Client is  <input type="checkbox" data-cb-group="ClientType"  name="${element.personId}_ClientType" value="Selling" data-checkbox-list="">&nbsp;<span class="tb">Buying</span>   <input type="checkbox" data-cb-group="ClientType" name="${element.personId}_ClientType" value="Buying" data-checkbox-list="">&nbsp;<span class="tb">Selling</span>  </td></tr>
                  </table>
                </div>`;
        }
      });
      return html;
    }

    clientsArray.forEach((element) => {
      if (element.isCorp) {
        element.signers.forEach((signer) => {
          html += `
              <div  style="border: 1px solid #000; padding: 10px; margin-bottom: 10px;">
            <div class="no-block" style="display: flex;  align-items: center; margin-bottom: 10px;">
                  ${labelType === "REFERRING_AGENT" ? "Referred From:" : "Referred To:"}
                     <i class="bi bi-pencil-square no-print clickable"
                      ${editIconDataAttr}
                        data-edit-modal-title="${editModalTitle}"
                      data-corp-signer 
                      data-labelType="${labelType}"
                  data-signer-personId="${signer.personId}"
                  data-signer-uuid-key="${element.key}"
                  style="color: blue; margin-left: 10px;"></i>    <i class="bi bi-plus  no-print clickable"  ${clientAttribute}  data-edit-modal-title="${editModalTitle}" data-labelType="${labelType}" data-add-as-self
                  style="
                    background-color: #085191;  
                    color: white;
                    margin-left: 30px;
                    border-radius: 50%;
                    padding: 8px;
                    font-size: 25px;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    width: 30px;
                    height: 30px;
                    cursor: pointer;
                  "
                ></i>
                </div>
                <table class="tableWidth" style="border: 0; width: 100%;">
                  <tr><td style="padding-left: 20px;">Company Name: <span class="ua">${signer.firmName || ""}</span></td></tr>
                  <tr><td style="padding-left: 20px;">Company Address: <span class="ua">${signer.address || ""}</span></td></tr>
                  <tr><td style="padding-left: 20px;">Company Phone: <span class="ua">${formatPhoneNumber(signer.officePhoneNumber)}</span> </td></tr>
                  <tr><td style="padding-left: 20px;">Fax #: <span class="ua">${formatPhoneNumber(signer.faxNumber)}</span> </td></tr>
                  <tr><td style="padding-left: 20px;">Agent Name: <span class="ua">${signer.fullName}</span></td></tr>
                  <tr><td style="padding-left: 20px;">Agent Phone: <span class="ua">${formatPhoneNumber(signer.phoneNumber)}</span></td></tr>
                  <tr><td style="padding-left: 20px;">Agent Email: <span class="ua">${signer.email || ""}</span></td></tr>
    
                </table>
              </div>`;
        });
      } else {
        const uuidKey = element.key || element.personId;
        const personId = element.personId || element._id;

        html += `
            <div  style="border: 1px solid #000; padding: 10px; margin-bottom: 10px;">
              <div class="no-block" style="display: flex;  align-items: center; margin-bottom: 10px;">
                ${labelType === "REFERRING_AGENT" ? "Referred From:" : "Referred To:"}
                <i class="bi bi-pencil-square no-print clickable"
                      ${editIconDataAttr}
                      data-edit-modal-title="${editModalTitle}"
                          data-labelType="${labelType}"
                  data-signer-personId="${personId}"
                  data-signer-uuid-key="${uuidKey}"
                 style="color: blue; margin-left: 10px;"></i> <i class="bi bi-plus  no-print clickable"  ${clientAttribute}  data-edit-modal-title="${editModalTitle}" data-labelType="${labelType}" data-add-as-self
                  style="
                    background-color: #085191;  
                    color: white;
                    margin-left: 30px;
                    border-radius: 50%;
                    padding: 8px;
                    font-size: 25px;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    width: 30px;
                    height: 30px;
                    cursor: pointer;
                  "
                ></i>
              </div>
              <table class="tableWidth" style="border: 0; width: 100%;">
                <tr><td style="padding-left: 20px;">Company Name: <span class="ua">${element.firmName || ""}</span></td></tr>
                <tr><td style="padding-left: 20px;">Company Address: <span class="ua">${element.address || ""}</span></td></tr>
                <tr><td style="padding-left: 20px;">Company Phone: <span class="ua">${formatPhoneNumber(element.officePhoneNumber)}</span></td></tr>
                <tr><td style="padding-left: 20px;">Fax #: <span class="ua">${formatPhoneNumber(element.faxNumber)}</span> </td></tr>
                <tr><td style="padding-left: 20px;">Agent Name: <span class="ua">${element.fullName}</span></td></tr>
                <tr><td style="padding-left: 20px;">Agent Phone: <span class="ua">${formatPhoneNumber(element.phoneNumber)}</span></td></tr>
                <tr><td style="padding-left: 20px;">Agent Email: <span class="ua">${element.email || ""}</span></td></tr>
              </table>
            </div>`;
      }
    });
    return html;
  } catch (error) {
    return "";
  }
};

export default buildDynamicBlocksForReferalForm;
